export default {
  avatar (state) {
    if (state.entity.avatar) {
      return state.entity.avatar
    }
    // return `${state.entity.name[0]}${state.entity.lastName[0]}`
    return `${state.entity.name[0]}`
  },

  hasAvatar (state) {
    return !(state.entity.avatar === undefined || state.entity.avatar === null)
  },

  fullName (state) {
    return `${state.entity.name} ${state.entity.lastName}`
  },

  defaultObject () {
    return {
      id: null,
      name: '',
      email: '',
      username: '',
      token: null
    }
  }
}